/**
 * Parar qualquer varredura ou leitura em andamento (R01-08): o botão Parar com a confirmação, o aviso de leitura
 * parada e o estado "Parada por <pessoa> às <hora>", iguais em todas as telas de conexão.
 */
const en = {
  'stop.button': 'Stop',
  'stop.confirmTitle': 'Stop the read of {name}?',
  'stop.confirmText':
    'The read stops at the next step. What was already read stays as it was: nothing is deleted or marked as gone, and the next scheduled read runs as usual.',
  'stop.confirm': 'Stop the read',
  'stop.done': 'Read stopped. What was already read stays as it was.',
  'stop.by': 'Stopped by {who} at {when}',
  'stop.state': 'Stopped',
};

const ptBR: Record<keyof typeof en, string> = {
  'stop.button': 'Parar',
  'stop.confirmTitle': 'Parar a leitura de {name}?',
  'stop.confirmText':
    'A leitura para na próxima etapa. O que já foi lido fica como estava: nada é apagado nem marcado como desaparecido, e a próxima leitura agendada segue normal.',
  'stop.confirm': 'Parar a leitura',
  'stop.done': 'Leitura parada. O que já foi lido ficou como estava.',
  'stop.by': 'Parada por {who} às {when}',
  'stop.state': 'Parada',
};

const es: Record<keyof typeof en, string> = {
  'stop.button': 'Detener',
  'stop.confirmTitle': '¿Detener la lectura de {name}?',
  'stop.confirmText':
    'La lectura se detiene en el próximo paso. Lo que ya se leyó queda como estaba: nada se borra ni se marca como desaparecido, y la próxima lectura programada sigue normal.',
  'stop.confirm': 'Detener la lectura',
  'stop.done': 'Lectura detenida. Lo que ya se leyó quedó como estaba.',
  'stop.by': 'Detenida por {who} a las {when}',
  'stop.state': 'Detenida',
};

export const readStopMessages = { en, 'pt-BR': ptBR, es } as const;
